import { defineStore } from 'pinia';
import { softswiss } from '../transport/softswiss';
import type { TLanguage } from '~/types/language';

export const useStoreSsLocales = defineStore('ssLocales', {
  actions: {
    /**
     * Method for sending request to SS API.
     * Request send user's stag and get set-cookie response
     * that write this stag in user's cookie
     *
     * @param stag affiliate identifier
     */
    async saveStag(stag: string, uniq_id: string) {
      const request = await softswiss().get({
        path: '/api/info/locales',
        params: { stag, utm_term: uniq_id } as {
          [key: string]: string;
        },
        cacheble: false,
        force: true,
      });

      return !!request;
    },

    async saveRefCode(refCode: string) {
      const request = await softswiss().get({
        path: '/api/info/locales',
        params: { ref_code: refCode } as { [key: string]: string },
        cacheble: false,
        force: true,
      });

      return !!request;
    },

    /**
     * Method of sending requests to the SS API.
     * The request sends the user's language: 'en' || 'ja' || 'ru' ...
     *
     * @param lang language type
     */
    async updateLocale(lang: TLanguage) {
      try {
        await softswiss().patch({
          path: '/api/player/update_locale',
          force: true,
          payload: { locale: lang } as { [key: string]: string },
        });
      } catch (e: any) {
        console.error(e);
      }
    },
  },
});
